import styled from '@emotion/styled'

export const Img = styled.img`
  display: block;
  height: auto;
  max-width: 100%;
  width: 100%;
`
